module.exports = require("@swa-ui/core/src/Loading/Loading.module.scss");